import { Map } from 'immutable'
import { createUrl } from 'utils/url'

export const INITIAL_STATE = Map({
  url: undefined,
  prevUrl: createUrl(window.location),
})
